import { Sector } from 'recharts';

export const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, value } = props;
  return (
    <g>
      <text x={cx} y={cy} dy={-10} textAnchor="middle" fill="#fff" fontSize={14} fontWeight="bold">
        {payload.name} : {value}
      </text>
      <text x={cx} y={cy} dy={15} textAnchor="middle" fill="#9ca3af" fontSize={12}>
        Total Bugs
      </text>
      <Sector
        cx={cx} cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 8}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        cornerRadius={5}
      />
    </g>
  );
};

export const renderActiveShapeCoverage = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, value } = props;
  return (
    <g>
      <text x={cx} y={cy} dy={0} textAnchor="middle" fill="#fff" fontSize={14} fontWeight="bold">
        {payload.name} : {value}%
      </text>
      <Sector
        cx={cx} cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 8}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        cornerRadius={5}
      />
    </g>
  );
};

export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="p-4 rounded-xl bg-[#0b0d13] border border-gray-800 shadow-2xl space-y-2">
        <p className="text-sm font-bold text-white mb-2">{label}</p>
        <p className="text-xs font-medium text-green-400 flex items-center justify-between gap-4">passed : <span className='font-bold'>{payload[0].value}</span></p>
        <p className="text-xs font-medium text-red-400 flex items-center justify-between gap-4">failed : <span className='font-bold'>{payload[1].value}</span></p>
      </div>
    );
  }
  return null;
};
